import "./bootstrap";
import "../css/app.css";

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import * as Sentry from "@sentry/vue";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
// FontAwesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { all } from "@awesome.me/kit-787feef9d2/icons";
library.add(...all);

const appName = import.meta.env.VITE_APP_NAME || "Vamp";

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue"),
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });

        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            environment: "production",
        });

        app.use(plugin)
            .use(ZiggyVue)
            .component("faIcon", FontAwesomeIcon)
            .mount(el);

        return app;
    },
    progress: {
        color: "#4B5563",
    },
});
